import NextImage from "next/image"
import cn from "classnames"
import Breadcrumbs from "components/Breadcrumbs"
import Image from "components/Image"
import CallToAction from "components/CallToAction"
import Map from "components/Map"
import richText from "utilities/richText"
import getTelLink from "utilities/getTelLink"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import isRichTextValid from "utilities/isRichTextValid"

export default function LocationPageHeader({ blok }) {
  return (
    <header className="md:py-12 relative overflow-hidden bg-primary">
      <NextImage
        alt=""
        src="/assets/blue-weave.webp"
        quality={80}
        fill
        placeholder="blur"
        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mMUUvGoBwABzQD/+RWwWwAAAABJRU5ErkJggg=="
        sizes="100vw"
        style={{
          objectFit: "cover",
        }}
        priority
        aria-hidden
      />

      <div className="md:px-5 pb-7 md:pt-7">
        <div className="flex flex-col md:flex-row md:gap-x-4 max-w-screen-xl mx-auto">
          <div className="w-full md:order-last flex flex-col items-center md:basis-1/2">
            {blok?.image?.filename && blok.image.filename !== "" ? (
              <Image src={blok?.image?.filename} alt={blok.image.alt} height="600" width="800" priority />
            ) : null}
            {blok?.lng && blok?.lat ? (
              <div className="h-48 md:min-h-[260px] md:h-full w-full pb-4 md:pb-0">
                <Map lng={blok?.lng} lat={blok?.lat} initialZoom={14} locations={[blok]} />
              </div>
            ) : null}
          </div>

          <div
            className={cn("px-5 md:px-0 z-10", {
              "md:basis-1/2": blok?.image?.filename,
            })}
          >
            <Breadcrumbs breadcrumbs={blok?.breadcrumbs} />
            <h1 className="text-white py-2 capitalize">{blok.heading}</h1>
            <div className="flex flex-col gap-2 pb-4">
              {blok?.map_link && blok?.address ? (
                <CallToAction href={getStoryblokLink(blok?.map_link)} style="secondary">
                  {blok?.address}
                </CallToAction>
              ) : null}
              {blok?.phone?.length ? (
                <CallToAction href={getTelLink(blok?.phone)} style="secondary">
                  {blok?.phone}
                </CallToAction>
              ) : null}
            </div>
            {isRichTextValid(blok.content) && (
              <div className="text-white prose-headings:text-white prose-headings:pb-4">{richText(blok.content)}</div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
